import { locationServiceInstance } from './location.service.instance';

export type GeoComplyLicenseResponse = {
  id: string;
  data: {
    license: string;
    expires: string;
  };
};

export type GeoComplyLocationData = {
  country?: string;
  state?: string;
  // /check/location returns these as epoch milliseconds; older payloads used an ISO string.
  expiresAt?: string | number;
  exp?: string | number;
};

export type GeoComplyLocationCheckResponse = {
  id?: string;
  data: GeoComplyLocationData & {
    data?: GeoComplyLocationData;
  };
};

export const getGeoComplyLicense = async (platform = 'web') => {
  const response = await locationServiceInstance.get<GeoComplyLicenseResponse>(
    '/location/license',
    {
      params: { platform },
    }
  );

  return response.data;
};

export const checkGeoComplyLocation = async (locationToken: string) => {
  const response = await locationServiceInstance.get<GeoComplyLocationCheckResponse>(
    '/check/location',
    {
      headers: {
        'location-token-v2': locationToken,
      },
    }
  );

  return response.data;
};
